import script from "./ColorPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./ColorPicker.vue?vue&type=script&setup=true&lang=js"

import "./ColorPicker.vue?vue&type=style&index=0&id=3dda6616&lang=scss"

const __exports__ = script;

export default __exports__